'use client';

import { c as _c } from "react/compiler-runtime";
import './modal.scss';
import { Close as RdxClose, Content as RdxContent, Overlay as RdxOverlay, Portal as RdxPortal, Root as RdxRoot, DialogProps as RdxRootProps, Trigger as RdxTrigger } from '@radix-ui/react-dialog';
import { ComponentPropsWithoutRef, type JSX } from 'react';
import { CloseButton } from '../../atoms/close-button/close-button.tsx';
import { cn } from '../../utils/helpers.ts';
export interface ModalProps extends ComponentPropsWithoutRef<'div'> {
  defaultOpen?: RdxRootProps['defaultOpen'];
  modal?: RdxRootProps['modal'];
  onClose?: () => void;
  onOpen?: () => void;
  onOpenChange?: RdxRootProps['onOpenChange'];
  open?: RdxRootProps['open'];
}
export const Modal: React.FC<ModalProps> = t0 => {
  const $ = _c(14);
  let children;
  let onClose;
  let onOpen;
  let onOpenChange;
  let rdxProps;
  if ($[0] !== t0) {
    ({
      children,
      onClose,
      onOpen,
      onOpenChange,
      ...rdxProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = onClose;
    $[3] = onOpen;
    $[4] = onOpenChange;
    $[5] = rdxProps;
  } else {
    children = $[1];
    onClose = $[2];
    onOpen = $[3];
    onOpenChange = $[4];
    rdxProps = $[5];
  }
  let t1;
  if ($[6] !== onClose || $[7] !== onOpen || $[8] !== onOpenChange) {
    t1 = open => {
      if (onOpenChange) {
        onOpenChange(open);
      }
      if (onOpen && open) {
        onOpen();
      } else {
        if (onClose && !open) {
          onClose();
        }
      }
    };
    $[6] = onClose;
    $[7] = onOpen;
    $[8] = onOpenChange;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== children || $[11] !== rdxProps || $[12] !== t1) {
    t2 = <RdxRoot onOpenChange={t1} {...rdxProps}>{children}</RdxRoot>;
    $[10] = children;
    $[11] = rdxProps;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};

/**
 * Modal content.
 */
export interface ModalContentProps extends ComponentPropsWithoutRef<typeof RdxContent> {
  className?: string;
}
export const ModalContent: React.FC<ModalContentProps & {
  ref?: React.Ref<HTMLDivElement>;
}> = ({
  style,
  className,
  ref,
  ...props
}) => {
  return <RdxPortal>
      <RdxOverlay className="Modal__overlay" />
      <RdxContent ref={ref} aria-describedby={undefined} className={cn('Modal__content', {
      [`${className}`]: !!className
    })} style={{
      ...style
    }} {...props} tabIndex={undefined}>
        {props.children}
      </RdxContent>
    </RdxPortal>;
};

/**
 * Modal trigger.
 */
export type ModalTriggerProps = {
  children: JSX.Element;
};
export const ModalTrigger: React.FC<ModalTriggerProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <RdxTrigger asChild={true}>{children}</RdxTrigger>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};

/**
 * Modal close.
 */
export const ModalClose = RdxClose;

/**
 * Modal title.
 */

/**
 * Modal close button.
 */
export const ModalCloseButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  name?: string;
}> = ({
  className,
  name,
  ...props
}) => {
  return <ModalClose asChild>
      <CloseButton className={cn('Modal__close', {
      [`${className}`]: !!className
    })} aria-label={`Close ${name}`} {...props} />
    </ModalClose>;
};
export { Title as ModalTitle } from '@radix-ui/react-dialog';